import type React from 'react';
import { BraidProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';

export const BraidWrapper = ({ children }: { children: React.ReactNode }) => (
  <BraidProvider theme={seekJobs}>{children}</BraidProvider>
);
